var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoneStepCis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4816_77620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9977 19.2274L33.2857 19.3959C33.853 19.7279 34.0474 20.4631 33.7199 21.0381L31.2701 25.3384C30.9426 25.9134 30.2171 26.1104 29.6498 25.7784L29.3617 25.6099C28.5815 25.1534 28.0564 24.3539 27.9418 23.4482C27.8591 22.7944 27.1734 22.4104 26.5832 22.6872L25.8397 23.0359C25.5345 23.1791 25.1797 23.1628 24.8885 22.9924L20.5508 20.7333C20.1276 20.4857 19.9333 19.9717 20.0848 19.5009L20.4102 18.1431C20.5113 17.8292 20.3836 17.4806 20.0848 17.3491C17.6992 16.3 14.1211 17.9386 14.1211 16.127C14.1211 14.3154 20.1332 11.979 24.1263 14.3155L28.5257 16.6107C28.8169 16.7811 29.0069 17.0837 29.0372 17.4231L29.1109 18.25C29.1695 18.9065 29.8405 19.3162 30.4405 19.0619C31.2717 18.7097 32.2175 18.7709 32.9977 19.2274Z",
    stroke: "#707070",
    strokeWidth: 1.77778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2618 20.4453L13.5013 32.4356C13.177 32.9391 13.3364 33.6153 13.8501 33.9159L15.7372 35.02C16.2509 35.3206 16.9084 35.1224 17.1765 34.5861L23.8981 22.3649",
    stroke: "#707070",
    strokeWidth: 1.77778
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4816_77620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoneStepCis);
export default __webpack_public_path__ + "static/media/undone-step-cis.7ce07d0228ca1fd740d23914310ddd55.svg";
export { ForwardRef as ReactComponent };